import React from 'react';

import { ICONS } from 'shared/presentation/constants';

import { PhoneRequiredModal } from './components';
import { useSocialLogin } from './hooks';
import * as S from './styles';

interface IGoogleSocialLoginButton {
  children: string;
}

const GoogleSocialLoginButton: React.FC<IGoogleSocialLoginButton> = ({
  children,
}) => {
  const controller = useSocialLogin();

  return (
    <>
      <S.Container
        icon={ICONS.GOOGLE_COLOR}
        outline
        onClick={() => controller.login()}
        loading={controller.loading}
      >
        {children}
      </S.Container>

      {controller.phoneRequired && (
        <PhoneRequiredModal
          loading={controller.loading}
          onClose={controller.closePhoneModal}
          onSubmit={controller.submitPhone}
        />
      )}
    </>
  );
};

export default GoogleSocialLoginButton;
